import { FC, HTMLAttributes, SVGProps } from 'react'
import s from './ChevronWithTooltip.module.sass'
import { Tooltip } from '@shared/ui/Overlays/Tooltip'
import { Text } from '@shared/ui/Typography/Text'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

interface Props {
  icon: FC<SVGProps<SVGSVGElement>>
  className?: string
}

const ChevronWithTooltip: FC<Props & HTMLAttributes<HTMLDivElement>> = ({ icon, className = '', ...props }) => {
  const IconChevron = icon
  return (
    <BlockBoundary>
      <div className={`chevron ${className ? className : s.chevron}`} {...props}>
        <Tooltip>
          <Tooltip.Trigger>
            <IconChevron />
          </Tooltip.Trigger>

          <Tooltip.Content>
            <Text sizes={'S'} className={s['tooltip-text']}>
              Выбор Афиши
            </Text>
          </Tooltip.Content>
        </Tooltip>
      </div>
    </BlockBoundary>
  )
}

export default ChevronWithTooltip
